<script setup>
/**
 * Logo wall — replaced the v1 stats strip (which now lives in ROIStatsBlock).
 * Kept as a single line of placeholder logos until real customer logos arrive.
 * Pattern: grayscale on idle, color-on-hover (TimeCamp / Jibble) — done with
 * a CSS filter so the swap is cheap and works for any logo asset.
 */
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <section class="py-12 lg:py-14 bg-background border-b border-border">
    <div class="container mx-auto px-6">
      <p class="text-center text-xs font-semibold tracking-widest uppercase text-muted-foreground mb-8">
        {{ t("landing.social_proof.heading") }}
      </p>

      <!-- Logo wall placeholder — marketing team replaces each <div> with
           an <img src="@/assets/landing/logos/<client>.svg" /> when ready.
           Grayscale-to-color on hover is the standard B2B pattern. -->
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-x-8 gap-y-6 max-w-5xl mx-auto items-center">
        <div
          v-for="i in 6"
          :key="i"
          class="h-10 rounded-md border border-dashed border-border flex items-center justify-center text-[10px] uppercase tracking-wider text-muted-foreground/60 font-mono grayscale hover:grayscale-0 hover:opacity-100 opacity-70 transition-all"
        >
          Logo cliente {{ i }}
        </div>
      </div>
    </div>
  </section>
</template>
